<!-- Filter - Search - Form  -->
<div *ngIf="permissionMap?.customers_v" class="data-action-form">
  <div class="row justify-content-between align-items-end" [formGroup]="customerForm">
    <div class="col-12 col-sm-12 col-md-7 col-lg-6 col-xl-5">
      <div class="row mx-n2 align-items-end">
        <div class="col-12 col-sm-6 col-md col-lg-4 col-xl px-2">
          <div class="form-group">
            <label>Customer Name</label>
            <select formControlName="name" class="form-control select2" #name>
              <option selected="" value="">Customer Name</option>
              <option *ngFor="let item of arCustomerDataSearch" [value]="item.name">{{ item.name }}</option>
            </select>
            <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
              <input type="text" formControlName="name" id="name" (blur)="searchInCustomer(name.value, 'name')" />
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md col-lg-4 col-xl px-2">
          <div class="form-group">
            <label>Customer ID</label>
            <select formControlName="customer_id" class="form-control select2" #customer_id>
              <option selected="" value="">Customer ID</option>
              <option *ngFor="let item of arCustomerDataSearch" [value]="item.customer_id">
                {{ item.customer_id }}
              </option>
            </select>
            <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
              <input
                type="text"
                formControlName="customer_id"
                id="customer_id"
                (blur)="searchInCustomer(customer_id.value, 'customer_id')" />
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md col-lg-4 col-xl px-2">
          <div class="form-group">
            <div class="search-box">
              <div class="form-group">
                <input
                  type="text"
                  #search
                  placeholder="Search"
                  class="form-control fild"
                  (keyup)="searchInCustomer(search.value, 'search')" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-12 col-md-5 col-lg-6 col-xl-7" *ngIf="userPermissions?.customers?.edit">
      <div class="text-right">
        <a href="javascript:;" class="btn btn-primary mb-3 mr-2" (click)="generateCSV()">Export to Excel</a>
      </div>
    </div>
  </div>
</div>
<!-- Filter - Search - Form  End-->
<div *ngIf="userPermissions?.customers?.view" class="data-table-scroll-container">
  <div class="table-responsive">
    <table class="table customers-data-table">
      <thead>
        <tr>
          <th>Customer Name</th>
          <th>Customer ID</th>
          <th>Contact Name</th>
          <th>Email</th>
          <th>Phone Number</th>
          <th>Portal Website/Billing Email</th>
          <th></th>
        </tr>
      </thead>
      <tbody *ngIf="arCustomerData.length > 0">
        <tr *ngFor="let item of arCustomerData">
          <td>{{ item.name }}</td>
          <td>{{ item.customer_id }}</td>
          <td>{{ item.billing_contacts?.contacts[0].contactName }}</td>
          <td>{{ item.billing_contacts?.contacts[0].contactEmail }}</td>
          <td>{{ item.billing_contacts?.contacts[0].phoneNumber | mask: '(000) 000-0000' }}</td>
          <td>{{ item.billing_contacts?.contacts[0].billingEmail }}</td>
          <td class="text-right">
            <a
              [class.disabled]="permissionMap.customers_v && !permissionMap.customers_e"
              href="javascript:void(0);"
              (click)="openAddEditCustomers(item.id)"
              ><i class="far fa-pen"></i
            ></a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
